import type { TableView } from 'owa-mail-list-store';
import { mutatorAction } from 'satcheljs';
import { isSingleLineListView } from 'owa-mail-layout';

const resetSelectAllStateMutator: (tableView: TableView) => void = mutatorAction(
    'resetSelectAllState',
    function resetSelectAllState(tableView: TableView): void {
        tableView.isInSelectAllState = isSingleLineListView();
    }
);
export default resetSelectAllStateMutator;
